import React, { useState } from 'react'
import PopOver from '../../global/PopOver';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEdit, faPlus, faTrash, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import DatePicker from "react-datepicker";
import ReactSelectPagination from '../../global/ReactSelectPagination';
import mainAxios from '../../../services/mainAxios';
import func from '../../../services/functions';
import moment from 'moment';
import { toast } from 'react-toastify';


const SummaryInvoiceList = ({disabled,invoiceState,setInvoiceState,errors,customStyles}) => {
  const { t ,i18n} = useTranslation("translations");
  const [invoices,setInvoices] = useState([])
  const [searchValue,setSearchValue]=useState(null)
  const defaultEditable = {
    id: null,
    iicRef: "",
    iicRefIssueDateTime: ""
  }
  const [editable,setEditable]=useState(defaultEditable)
  
  const [summaryReq,setSummaryReq]=useState({
    totalRows: 0,
    pageSize: 10,
    pageNumber: 1,
    loading:false
  })

console.log({invoiceState,editable})
  const handleSummaryObjChange = (obj, index) => {
    setInvoiceState((invoiceState) => {
      const summaryInvIICRefs = [...invoiceState.summaryInvIICRefs];
      summaryInvIICRefs[index] = obj
      return {
        ...invoiceState,
        summaryInvIICRefs,
      };
    });
  }  


    const handleAddSumInvEntry = ({iicRef="",iicRefIssueDateTime=""}={}) => {
      const firstSummaryIIcRef=invoiceState.summaryInvIICRefs?.[0]
      const alreadyExists = invoiceState.summaryInvIICRefs.some(
        (item) => item.iicRef === iicRef && item.iicRefIssueDateTime === iicRefIssueDateTime
      );
    if (alreadyExists) {
      toast.error("IIC ref already exists", {
        containerId: "all_toast",
      });
      return;
    }
    setInvoiceState((invoiceState) => ({
      ...invoiceState,
      summaryInvIICRefs:invoiceState.summaryInvIICRefs?.length==1 && firstSummaryIIcRef.iicRef=="" && firstSummaryIIcRef.iicRefIssueDateTime==""?[{ iicRef,  iicRefIssueDateTime }] :[
        { iicRef,  iicRefIssueDateTime },
        ...invoiceState.summaryInvIICRefs,
      ],
    }));
    setSearchValue(null);
    setInvoices([])
    setEditable(defaultEditable)
  };

  const handleDeleteSumInvEntry = (index) => {
    setInvoiceState((invoiceState) => ({
      ...invoiceState,
      summaryInvIICRefs: invoiceState.summaryInvIICRefs.filter((_, i) => i !== index),
    }));
  };


  
    const getFilteredResults = (
      {
        searchQuery,
        pageSize =10,
        page = 1,
        loadMore
      }={}
    ) => {
      if(!searchQuery || searchQuery?.length==0){
        return
       }
       setSummaryReq((state)=>({...state,loading:true}))
      let requestBody = {
        object: "GetQueueV",
        value: null,
        params:{
          iic:`<L>${searchQuery}<L>`,
          businessUnitCode: null,
          operatorCode: null,
          tcrCode: null,
          isEinvoice: null,
          ublId: null,
          correctiveInvoiceType: null,
          ublInvoiceTypeCode: null,
          isForeign: null,
          ublCurrency: null,
          invoiceStatus: null,
          fiscInvoiceType: null,
          ublProfileId: null,
          isOldInvoice: null,
          isDifferentPeriod: null,
          period: null,
          fromCis: null,
          external: "false"
        },
        fromDate:func.getDateFromToday(-30),
        toDate:func.getDateFromToday(1),
        pagination:  {
            pageSize,
            pageNumber: page,
        },
        sortCriteria:[{
          field: "issueDatetime",
          direction: "DESC"
        } ]
      };
  
      return mainAxios
        .post(`apiEndpoint/search`, requestBody)
        .then((res) => {
          setSummaryReq((state)=>({...state,loading:false}))
          if (res?.data?.status) {
            let data = res.data?.content ?? []
            setInvoices((invoices)=>loadMore?invoices.concat(data):data);
            return data
          }
        })
        .catch((err) => {
           setSummaryReq((state)=>({...state,loading:false}))
          return null;
        });
    };
  const popoverPoisition={position:"absolute",right:-24,top:-2}

  return (
    <div className='w-full'>
      <div className="mb-2"> 
        {!disabled ? <div className='mt-2'>
          <label className="form-label mt-2 relative">
            Search Reference Invoices 
          </label>
          <ReactSelectPagination
            styles={customStyles}
            options={invoices}
            onChange={(invoice)=>{if(invoice)handleAddSumInvEntry({iicRef:invoice.iic,iicRefIssueDateTime:invoice.issueDatetime})}}
            getOptionLabel={(option)=>option?.iic}
            getOptionValue={(option)=>option?.id}
            getFilteredResults={getFilteredResults}
            pagination={summaryReq}
            setPagination={setSummaryReq}
            value={searchValue}
            isClearable={true}
            placeholder="IIC"

            />
        </div>:
        <label className='field-label mt-1'>{t("invoice.referenceInvoices")}</label>
        }
         {!disabled && invoiceState.summaryInvIICRefs[0]?.iicRef?.length>0 && invoiceState.summaryInvIICRefs?.[0]?.iicRefIssueDateTime!="" && (
          <div className='d-flex justify-content-end mt-2'>
              <button className="btn btn-outline-primary btn-xs" style={{ minWidth: "60px"}} onClick={()=>{
                handleAddSumInvEntry()
                setEditable({summaryInvIICRefs:"",iicRef:"",id:0})
              }}>
                {t("invoice.addManually")}
              </button>
          </div>
        )}
        {
           invoiceState.summaryInvIICRefs.map(((iicRefObj, index) => {
            if(editable?.id ==index){
            return (
              <div key={index}>
                <div className="d-flex justify-content-between align-items-center">
                  <label className="form-label mt-2 relative">
                    {t("purchases.iicRef")} <span className="text-danger">*</span>
                    <span style={popoverPoisition}><PopOver title={t("invoice.IICInvoiceCorrecedSumInv")} /></span>
                  </label>
                </div>

                <input
                  type="text"
                  className={`form-control form-control-sm ${ errors[index+"_"+"iicRef"] ? "is-invalid" : "" }`}    
                  disabled={disabled}
                  value={editable?.iicRef ?? ""}
                  onChange={(e) => {
                    console.log({event:e})
                    const iicRef= e.target?.value
                    setEditable((state)=>({
                      ...state,
                      iicRef
                    }))
                  }}
                />


                <label className="form-label mt-2 relative">
                  {t("invoice.refIssueDate")} <span className="text-danger">*</span>
                    <span style={popoverPoisition}><PopOver title={t("invoice.DateIssueCorrecedSummary")} /></span>
                  
                </label>
                <DatePicker
                  selected={editable?.iicRefIssueDateTime}
                  disabled={disabled}
                  dateFormat="dd/MM/yyyy"
                  autoComplete="off"
                  showDisabledMonthNavigation
                  onChange={date => {
                   setEditable((state)=>({
                      ...state,
                      iicRefIssueDateTime:date
                    }))
                    //  handleInvoiceChange(date, 'refInvIssueDateTime')
                  }}
                  customInput={<input id={index+"_"+"iicRef" +"date"}className={`form-control form-control-sm ${ errors[index+"_"+"iicRefIssueDateTime"] ? "is-invalid" : "" }`}   />}
                  portalId={ "datepicker-portal"} 
                />
                <div className='d-flex justify-content-end mt-1'>
                        <button
                          className="btn btn-outline btn-xs btn-success"
                          onClick={()=>{handleSummaryObjChange({iicRef:editable.iicRef,iicRefIssueDateTime:editable.iicRefIssueDateTime},index);setEditable(defaultEditable);}}
                        >
                            {t(["common.save"])}
                        </button>
                  {/* <FontAwesomeIcon icon={faCheck} className="mr-2 mt-1 cursor-pointer text-primary" style={{fontSize:20}} onClick={()=>{handleSummaryObjChange({iicRef:editable.iicRef,iicRefIssueDateTime:editable.iicRefIssueDateTime},index);setEditable(null);}} /> */}
                  </div>
              </div>
            )
            }
              return <div className={`mb-2 d-flex flex-column`}>
                <div style={{fontSize:13}}>
                    <div style={{fontWeight:700}} className={`${errors[index+"_"+"iicRef"] ? "text-danger":""}`}>{t("purchases.iicRef")}:</div>
                    <div>{iicRefObj.iicRef}</div>
                </div>
                <div style={{fontSize:13}}>
                    <div style={{fontWeight:700}} className={`font-bold  ${ errors[index+"_"+"iicRefIssueDateTime"] ? "text-danger"  :""}`}>{t("invoice.refIssueDate")}:</div>
                    <div >{iicRefObj.iicRefIssueDateTime&& moment(iicRefObj.iicRefIssueDateTime).format("DD/MM/YYYY")}</div>
                </div>
                {!disabled && <div className='d-flex justify-content-end align-items-center gap-2'>
                  <FontAwesomeIcon icon={faEdit} className="mr-1 cursor-pointer" size={20} onClick={()=>setEditable({...iicRefObj,id:index})} />
                  {invoiceState.summaryInvIICRefs?.length>1 && <FontAwesomeIcon   size={17} icon={faTrashAlt} className="mr-1 cursor-pointer" color={"red"} onClick={()=>handleDeleteSumInvEntry(index)}/>}
                </div>}
                
              </div>

          }))
        }
      </div> 
    </div>
  )
}

export default SummaryInvoiceList